<template>
    <va-edit-layout>
        <MwsSynchronization-form
            :id="id"
            :title="title"
            :item="item"
        ></MwsSynchronization-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
